<template>
  <span class="currency">
    <template v-if="value">
      <span v-for="(v, idx) in thousands" class="t" :key="`t-${value}-${idx}`">{{v}}</span>
      <span v-if="decimals !== false" class="d">.{{decimals}}</span>
      <span class="c"> {{currency}}</span>
    </template>
  </span>
</template>
<script>
export default {
  props: {
    value: { type: [Number, String], default: null },
    currency: { type: [String], default: 'EUR' },
    precision: { type: [Number], default: 2 },
  },
  computed: {
    decimals() {
      const p = parseInt(this.precision, 10);
      if (!this.value || p <= 0) return false;
      const found = this.value.toFixed(p).match(/\.(?<digits>\d*)$/);
      return found.groups.digits;
    },
    thousands() {
      const p = parseInt(this.precision, 10);
      let found = (this.value.toFixed(p).match(/^(?<thousands>\d*)/))?.groups?.thousands;
      const arr = [];
      while (found !== undefined && found.length) {
        const clength = Math.min(found.length, 3);
        arr.unshift(found.substring(found.length - clength));
        found = found.substring(0, found.length - clength);
      }
      return arr;
    },
  }
};
</script>
<style lang="scss">
.currency {
  font-variant-numeric: tabular-nums;

  span {
    &.t {
      padding-left: 0.2em;
    }

    &.d,
    &.c {
      font-size: 0.8em;
    }

  }
}
</style>
